import { render, staticRenderFns } from "./WantedListPage.vue?vue&type=template&id=27c5a31e&scoped=true"
import script from "./WantedListPage.vue?vue&type=script&lang=js"
export * from "./WantedListPage.vue?vue&type=script&lang=js"
import style0 from "./WantedListPage.vue?vue&type=style&index=0&id=27c5a31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5a31e",
  null
  
)

export default component.exports